import { emptyDecorator } from '@/catalog/constants/emptyDecorator';
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import Diamond from '@/product/entity/Diamond';
export const FIELD_LW = {
    key: 'lengthMm',
    label: 'L × W',
    fullLabel: 'L × W',
    type: FieldType.Scalar,
    spGroupId: null,
    getter(p) {
        if (p instanceof Diamond && p.reportData) {
            if (p.reportData.length !== null && p.reportData.width !== null) {
                return `${p.reportData.length.toFixed(2)}x${p.reportData.width.toFixed(2)} mm`;
            }
        }
        return null;
    },
    getterPlain(p) {
        if (p instanceof Diamond && p.reportData) {
            if (p.reportData.length !== null && p.reportData.width !== null) {
                return `${p.reportData.length.toFixed(2)}x${p.reportData.width.toFixed(2)}`;
            }
        }
        return null;
    },
    decorator: emptyDecorator,
    iteratee: null,
    contexts: ALL_CONTEXTS,
};
